/**
 * Plugin to make all axios requests to use GET method when app is in dev mode.
 * Can be removed in production.
 */
export default ({ $axios, store, redirect, route }) => {
  $axios.onRequest((config) => {
    if (store.state.env === 'local') {
      config.method = 'get';
    }

    return config;
  });

  $axios.onError((error) => {
    const isAuthenticationError =
      error.response?.data?.errorCode === 1 || error.request.status === 401;

    if (isAuthenticationError) {
      store.commit('user/clearSession');
      store.dispatch('ui/showError', {
        title: 'Ops! Sessão Expirada',
        text: 'Para retomar de onde parou, faça login novamente.',
        callback: (button) => {
          const query = route.path === '/login' ? {} : { goto: route.path };
          redirect({ path: '/login', query: query });
        }
      });
    }
  });
};
